<template>
  <div>

    <b-row>
      <b-col cols="12" class="border-bottom">
        <vue-dropzone ref="addFile" id="addFile" :options="dropzoneOptions" :useCustomSlot="true" :include-styling="false"
          v-on:vdropzone-success="uploadSuccess" v-on:vdropzone-error="vdropzoneError">
          <div class="dropzone-custom-content">
            <b-button
              v-if="this.userData.userType != this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ? true : this.request_quotation && this.request_quotation.accept_edit == 1 ? true : false"
              variant="primary" class="btn-sm float-right my-1"><feather-icon icon="PlusIcon" /> Add
              File</b-button>
          </div>
        </vue-dropzone>
      </b-col>
    </b-row>
    <b-card-text>
      <vue-perfect-scrollbar :settings="{
        maxScrollbarLength: 150,
        suppressScrollX: true,
      }" style="max-height: 70vh" class="scrollable-container scroll-area">
        <vue-good-table :columns="document_columns" :rows="document_rows" :line-numbers="true">
          <template slot="table-row" slot-scope="props">
            <!-- Column: Action -->

            <span v-if="props.column.field === 'date'">
              {{ props.row.date }}
            </span>

            <span v-else-if="props.column.field === 'action'">
              <a v-if="checkInput(props.row.text, typeView)"><feather-icon @click="viewFile(props.row)" icon="EyeIcon" />
              </a>

              <a class="ml-1" :href="props.row.download_path"><feather-icon icon="DownloadIcon" /></a>

              <a v-if="userData.username == props.row.username ||
                userData.username == 'admin'
                " class="ml-1 text-danger" @click="removeFile(props.row)"><feather-icon icon="DeleteIcon" /></a>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </vue-perfect-scrollbar>
    </b-card-text>
    <b-modal v-model="fileNotes" title="Add File" size="lg" hide-footer>
      <b-card-text>
        <p>File: {{ nameFile }}</p>
        <b-form-group>
          <label>Notes</label>

          <b-form-textarea rows="4" v-model="notes"></b-form-textarea>
        </b-form-group>
        <b-button @click="saveFile" variant="primary" class="btn-sm float-right my-1">Save</b-button>
      </b-card-text>
    </b-modal>
    <b-modal id="view-file" title="View File" :size="type ? 'lg' : 'xl'" hide-footer>
      <div v-if="type">
        <img class="w-100" v-if="base64" style="display: block" id="base64image"
          :src="'data:image/png;base64,' + base64" />
      </div>

      <object v-else>
        <embed id="pdfID" class="w-100" style="height: 100vh" type="text/html"
          :src="'data:application/pdf;base64,' + base64" />
      </object>
    </b-modal>

  </div>
</template>

<script>
import {
  BTab,
  BTabs,
  BAvatar,
  BForm,
  BFormTextarea,
  BImg,
  BDropdown,
  BDropdownItem,
  BButton,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { VueGoodTable } from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import { $ctx } from "@themeConfig";
export default {
  props: {
    request_quotation: { default: null },
  },
  components: {
    VueGoodTable,
    BTab,
    BTabs,

    BAvatar,
    BForm,
    BImg,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormTextarea,
    ValidationProvider,
    BCardText,
    ValidationObserver,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    FeatherIcon,

    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      images: [

      ],
      fileNotes: false,
      type: true,
      base64: "",
      typeView: ["png", "jpg", "pdf", "jpeg", "gif", "bmp"],
      typeViewImg: ["png", "jpg", "jpeg", "gif", "bmp"],
      customer_list_options: [],
      nameFile: "",
      responseFileUp: "",
      notes: "",
      file: "",
      dropzoneOptions: {
        url: $ctx.API_URL + "uploadFile",
        previewsContainer: false,
        createImageThumbnails: false,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        destroyDropzone: true,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        headers: { apiKey: localStorage.getItem("accessToken") },
      },
      appLogoImage: require("@/assets/images/logo/logo.svg"),
      userData: JSON.parse(localStorage.getItem("userData")),
      document_columns: [
        {
          label: "Date",
          field: "date",
          width: "100px",
          tdClass: "text-center",
          filterOptions: { enabled: true },
        },
        {
          label: "Name",
          field: "fullName",
          width: "120px",
          tdClass: "text-center",
          filterOptions: { enabled: true },
        },
        {
          label: "File name",
          field: "text",
          filterOptions: { enabled: true },
        },
        {
          label: "Notes",
          field: "notes",
          filterOptions: { enabled: true },
        },
        {
          label: "Action",
          width: "120px",
          tdClass: "text-right pr-2",
          field: "action",
        },
      ],
      document_rows: [],
    };
  },
  watch: {},

  mounted() {

    if (
      this.request_quotation != null &&
      this.request_quotation.hasOwnProperty("files") &&
      !!this.request_quotation.files &&
      this.request_quotation.files.length > 0
    ) {
      this.request_quotation.files.map((e) => {
        const path = e.path.split(".")[0];

        e.fullName = e.fullName;
        e.text = e.name;
        e.notes = e.notes || "";

        e.download_path =
          $ctx.API_URL +
          "uploadFile/" +
          path +
          "?apiKey=" +
          localStorage.getItem("accessToken") +
          "&name=" +
          e.name;

        this.document_rows.push(e);
      });
    }

    if (
      this.request_quotation != null &&
      this.request_quotation.hasOwnProperty("accept_files") &&
      !!this.request_quotation.accept_files &&
      this.request_quotation.accept_files.length > 0
    ) {
      if (this.request_quotation.accept_files.length > 0) {
        this.request_quotation.accept_files.map((e) => {
          const path = e.path.split(".")[0];

          e.fullName = e.fullName;

          e.text = e.name;
          e.notes = e.notes || "";

          e.download_path =
            $ctx.API_URL +
            "uploadFile/" +
            path +
            "?apiKey=" +
            localStorage.getItem("accessToken") +
            "&name=" +
            e.name;

          this.document_rows.push(e);
        });
      }
    }

    // console.log(this.document_rows);
  },

  methods: {
    previewURL() {
      const $viewer = this.$viewerApi({
        images: this.images,
      })
      // console.log($viewer)
    },
    checkInput(input, words) {
      return words.indexOf(input.split(".").pop()) > -1;
    },
    viewFile(row) {
      this.type = this.checkInput(row.name, this.typeViewImg);
      this.$store
        .dispatch("attachFile/viewFile", {
          id: row.path,
          name: row.name,
        })
        .then((rs) => {
          if (rs.data.message == "success!") {
            if (this.type) {
              this.images = ['data:image/png;base64,' + rs.data.result]
              this.previewURL();
            } else {
              this.base64 = rs.data.result;
              this.$bvModal.show("view-file");
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: rs.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        });
    },
    async removeFile(row) {
      var bookingId =
        this.request_quotation.files.filter((e) => e.path == row.path).length >
          0
          ? "-1"
          : this.request_quotation.id;
      var res = await this.$bvModal.msgBoxConfirm(
        "Are you sure you want to delete this file?",
        { title: "Delete file", size: "sm" }
      );
      if (res) {
        this.document_rows = this.document_rows.filter(
          (e) => e.path != row.path
        );
        this.request_quotation.files = this.request_quotation.files.filter(
          (e) => e.path != row.path
        );
        this.$store.dispatch("attachFile/deleteFile", {
          bookingId: bookingId,
          request_quotation_id: this.request_quotation.bookingID,

          request_quotation_id: this.request_quotation.booking_id,
          request_quotation_files: this.request_quotation.files,
          path: row.path,
        });
      }
    },
    saveFile() {
      this.responseFileUp.isRequestFile =
        this.userData.userType ==
          this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
          this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin
          ? "0"
          : "1";
      this.responseFileUp.bookingId = this.request_quotation.id;
      this.responseFileUp.size = `${this.file.size}`;
      this.responseFileUp.notes = this.notes;

      this.$store.dispatch("attachFile/upFile", this.responseFileUp);



      this.responseFileUp.date = moment(new Date()).format(
        "DD/MM/YYYY HH:mm:ss"
      );

      this.responseFileUp.text = this.responseFileUp.name;
      this.responseFileUp.download_path =
        $ctx.API_URL +
        "uploadFile/" +
        this.responseFileUp.path +
        "?apiKey=" +
        localStorage.getItem("accessToken") +
        "&name=" +
        this.responseFileUp.name;
      this.responseFileUp.fullName = this.userData.fullName;

      this.document_rows.push(this.responseFileUp);
      this.fileNotes = false
      this.notes = "";
    },
    uploadSuccess: function (file, res) {
      this.responseFileUp = "";
      this.file = "";

      if (file && res.message == "success!") {
        this.nameFile = res.result.name;
        this.responseFileUp = res.result;
        this.fileNotes = true
        this.notes = ""
        this.file = file;
      }
    },
    vdropzoneError(file, errorMessage) {
      this.$refs.addFile.removeFile(file);

      if (errorMessage.includes("Max filesize: 10MiB")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadSizeErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      if (errorMessage.includes("You can not upload any more files.")) {
        this.responseFileUp = "";
        this.file = "";
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadLimitErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
  },
};
</script>